import React, {useState, useEffect, useTransition} from "react";
import "./DateNavigation.css";
import {ReactComponent as TimesLeftArrow} from "../../assets/icons/TimesLeftArrow.svg";
import {getWorkday} from '../../services/server-actions';
import {DateTime} from 'ts-luxon';
import {MobileTimesheetWorkDayResultDto} from '../../services/shared/service-proxies/service-proxies';

import moment from "moment-jalaali";

interface DateNavigationProps {
    onDateChange: (selectedDate: DateTime, persianDate: any) => void;
    initialDate?: DateTime; 
}

const DateNavigation: React.FC<DateNavigationProps> = ({ onDateChange, initialDate }) => {

    // دو state جداگانه
    const [selectedDate, setSelectedDate] = useState<DateTime | null>(initialDate ?? null);
    const [selectedMonth, setSelectedMonth] = useState(moment(DateTime.now().toISO()).format("jM"));
    const [workdayData, setWorkdayData] = useState<MobileTimesheetWorkDayResultDto[]>([]);

    // برای نمایش حالت Pending در حین دریافت داده‌ها (اختیاری)
    const [isPending, startTransition] = useTransition();
    moment.loadPersian({usePersianDigits: false});
    // به محض تغییر تاریخ (در واقع تغییر ماه)، داده‌های جدید را از سرور می‌گیریم
    useEffect(() => {
        const fetchWorkdayData = async () => {
          try {
            const data = await getWorkday();
            setWorkdayData(data);
      
            // 👇 اینجا اضافه کن
            if (
                data.length > 0 &&
                Array.isArray(data[0].workDay) &&
                data[0].workDay.length > 0
              ) {
                const firstWorkday = data[0].workDay[0];
                if (firstWorkday?.onDate && firstWorkday?.persian) {
                  setSelectedDate(firstWorkday.onDate);
                  onDateChange(firstWorkday.onDate, firstWorkday.persian);
                }
              }
              
      
          } catch (error) {
            console.error("Error fetching workday data:", error);
          }
        };
      
        fetchWorkdayData();
      }, []);
      

    const handleDateSelect = (date: DateTime, persiandate: any) => {
        startTransition(() => {
            setSelectedDate(date);
            onDateChange(date, persiandate);
        });
    };

    const handleMonthChange = (increment: number) => {
        let newMonthDate: number = parseInt(selectedMonth) + increment;

        if (selectedMonth == 12 && increment == 1)
            newMonthDate = 1;
        if (selectedMonth == 1 && increment == -1)
            newMonthDate = 12

        setSelectedMonth(newMonthDate);
        setSelectedDate(null);
    };
 
    const daysOfWeek = ["دوشنبه", "سه‌شنبه", "چهارشنبه", "پنج‌شنبه", "جمعه", "شنبه", "یک‌شنبه"];
    const PERSIAN_MONTHS = ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"];

    const makeDayList = (data: MobileTimesheetWorkDayResultDto) => {
        return data.workDay?.map((workday, index) => {
            const year = workday.persian?.split('/')[0]
            const month = workday.persian?.split('/')[1]
            const day = workday.persian?.split('/')[2]

            // moment.loadPersian({ usePersianDigits: false });
            // const persianDate = moment(date.toISO()).format("jYYYY/jM/jD");

            let isSelected = selectedDate?.toISODate() === workday.onDate.toISODate();

            if (isSelected && selectedDate != workday.onDate) {
                
                setTimeout(()=>{
                    handleDateSelect(workday.onDate, workday.persian)
                }, 100)
            }
            // @ts-ignore
            // @ts-ignore
            return (
                <div
                    key={workday.onDate.toISO()}
                    className={`day-item ${isSelected ? "selected" : ""} ${
                        isPending ? "loading" : ""
                    }`}
                    onClick={() => handleDateSelect(workday.onDate, workday.persian)}
                >
                    <div className="day-name">
                        {daysOfWeek[workday.onDate.weekday - 1]}
                    </div>
                    <div className="day-number">
                        {day}
                    </div>
                </div>
            );
        })
    }
    return (
        <div className="date-navigation-wrapper">
            <div className="date-navigation-header">
                <button
                    className="month-button"
                    onClick={() => handleMonthChange(-1)}
                    disabled={Math.min(...workdayData.map(item => item.month)) == selectedMonth}
                    style={{display: "flex", alignItems: "center", gap: "8px"}}
                >
                    <TimesLeftArrow style={{transform: "rotate(180deg)"}}/>
                    <span>ماه قبل</span>
                </button>

                <h6 className="current-month">
                    {PERSIAN_MONTHS[selectedMonth -1]}
                </h6>

                <button
                    className="month-button"
                    onClick={() => handleMonthChange(1)}
                    style={{display: "flex", alignItems: "center", gap: "8px"}}
                    disabled={Math.max(...workdayData.map(item => item.month)) == selectedMonth}
                >
                    <span>ماه بعد</span>
                    <TimesLeftArrow/>
                </button>
            </div>

            <div className="date-navigation-days">
                {

                    workdayData.map((data, index) => {
                        if (selectedMonth == data.month)
                            return makeDayList(data);
                    })
                }
            </div>
        </div>
    );
};

export default React.memo(DateNavigation);
